<template>
  <div class="problem">
    <!-- <div class="line"></div> -->
    <div style="overflow:hidden; margin-top:18px;">
      <div class="blue"></div>
      <p class="title">常见问题</p>
    </div>
    <div class="promblemrow">
      <div class="text">
        没有经验，零基础可以学习么？
        <img src="../assets/images/hot.png">
      </div>
      <span onclick="doyoo.util.openChat('g=10063915');return false;">学习难度</span>
    </div>
    <div class="promblemrow">
      <div class="text">
        对学历有什么要求？
        <img src="../assets/images/hot.png">
      </div>
      <span onclick="doyoo.util.openChat('g=10063915');return false;">学历要求</span>
    </div>
    <div class="promblemrow">
      <div class="text">
        什么是全日制就业班、全程班、定制班？
      </div>
      <span onclick="doyoo.util.openChat('g=10063915');return false;">班型模式</span>
    </div>
    <div class="promblemrow">
      <div class="text">
        课程培训费用是多少？
      </div>
      <span onclick="doyoo.util.openChat('g=10063915');return false;">报名学费</span>
    </div>
    <div class="promblemrow">
      <div class="text">
        课程学完需要多久？
      </div>
      <span onclick="doyoo.util.openChat('g=10063915');return false;">学习周期</span>
    </div>
    <div class="promblemrow">
      <div class="text">
        是否可以申请免费试听课？
        <img src="../assets/images/hot.png">
      </div>
      <span onclick="doyoo.util.openChat('g=10063915');return false;">免费试听</span>
    </div>
    <div class="promblemrow">
      <div class="text">
        学完不好找工作怎么办？

      </div>
      <span onclick="doyoo.util.openChat('g=10063915');return false;">就业问题</span>
    </div>
    <div class="otherrow">
      <span onclick="doyoo.util.openChat('g=10063915');return false;">还有其他问题 ></span>
    </div>
    <div class="endrow"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      questionList: []
    };
  },
  mounted() {
    this.axios
      .get("/api/Consume/CommonQuestion")
      .then(res => {
        this.questionList = res.data;
      });
  },
  methods:{
    go(item){
      switch(item.type){
        case 1:
          this.$router.push({path:`/studyInfo/basis/${item.id}.html`})
          break;
          case 2:
          this.$router.push({path:`/studyInfo/improve/${item.id}.html`})
          break;
          case 3:
          this.$router.push({path:`/studyInfo/industry/${item.id}.html`})
          break;
      }
    }
  }
};
</script>

<style>
.problem {
  padding-top: 10px;
  margin-bottom: 50px;
}
.problem .blue {
  width: 6px;
  height: 30px;
  background: #64b3f1;
  float: left;
  margin-top: 5px;
  margin-left: 30px;
}
.problem .title {
  font-size: 32px;
  color: #282828;
  font-weight: bold;
  float: left;
  margin-left: 22px;
  margin-bottom: 8px;
}

.promblemrow
{
  margin:25px 30px 0px 30px;
  padding-bottom:25px;
  display: flex;
  height:70px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e2e2e2;
}
.promblemrow .text
{
  font-size:27px;
}
.promblemrow .text img
{
  width:18px;
  height:24px;
}
.promblemrow span
{
  width:25%;
  display: flex;
  background-color:#9EBBFF;
  color:#FFFFFF;
  font-size:25px;
  height:80%;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  text-align: right;
}
.otherrow
{
  margin:40px 30px 40px 30px;
  padding-bottom:25px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.otherrow span
{
  width:350px;
  display: flex;
  color:#3E78FF;
  font-size:30px;
  height:80px;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  border: 1px solid #3E78FF;
  text-align: right;
}
.endrow
{
  width:100&;
  height:17px;
  background-color:#F4F4F4
}
</style>



// WEBPACK FOOTER //
// src/components/Problem.vue